import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=46a502e2&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=46a502e2&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a502e2",
  null
  
)

export default component.exports